import { motion, useInView } from "framer-motion"
import { Link, graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"

const ContactInfo = ({ module }) => {
  const ref = useRef(null)
  const [hasPlayed, setHasPlayed] = useState(false)
  const isInView = useInView(ref)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  if (module.hideSection === "no") {
    return (
      <React.Fragment>
        <motion.section
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`zigzag py-50 xlscreen:py-45 mdscreen:py-40 ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid-xl md2:!pr-30"
          >
            <div className="flex flex-wrap items-center">
              <motion.div
                variants={animFade}
                className="mdscreen2:w-full w-6/12 order-1 md2:order-2"
              >
                {module?.mapIframe && (
                  <div className="border-bg-offwhite">
                    <div className="img portrait">
                      {parse(module.mapIframe)}
                    </div>
                  </div>
                )}
              </motion.div>
              <div className="mdscreen2:w-full w-6/12 md2:pr-60 xl:!pr-80 mdscreen:pt-30 order-2 md2:order-1 mdscreen2:pt-45">
                <div className="md2:max-w-[578px]">
                  {module?.heading && (
                    <motion.div
                      variants={animFade}
                      className="title title-grey pt-35 mdscreen2:pt-0 uppercase"
                    >
                      <h3 className="font-500 tracking-0.04em">
                        {module.heading}
                      </h3>
                    </motion.div>
                  )}
                  <div className="content mt-50 lgscreen:mt-25">
                    {module?.contactDetails && (
                      <div className="grid gap-y-[28px]">
                        {module?.contactDetails.map((item, i) => (
                          <motion.div
                            variants={animFade}
                            className="flex flex-wrap items-start gap-x-[15px]"
                            key={i}
                          >
                            {item?.icon && (
                              <img
                                src={item.icon.mediaItemUrl}
                                width={24}
                                height={24}
                                loading="lazy"
                                alt={item.icon.title}
                              />
                            )}
                            {item?.details && (
                              <span className="text-15 font-400 opacity-70">
                                <Link to={item.details.url}>
                                  {item.details.title}
                                </Link>
                              </span>
                            )}
                          </motion.div>
                        ))}
                      </div>
                    )}
                    {module?.socialIcons && (
                      <motion.div
                        variants={animFade}
                        className="sicon relative mt-30 pt-30"
                      >
                        <ul className="flex flex-wrap gap-x-[15px]">
                          {module?.socialIcons.map((item, i) => (
                            <li>
                              {item?.icon && (
                                <Link
                                  to={item.links.url}
                                  target={item.links.target}
                                >
                                  <img
                                    src={item.icon.mediaItemUrl}
                                    width={28}
                                    height={28}
                                    loading="lazy"
                                    alt={item.icon.title}
                                  />
                                </Link>
                              )}
                            </li>
                          ))}
                        </ul>
                      </motion.div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.section>
      </React.Fragment>
    )
  }
}

export default ContactInfo
export const PageContactInfoFragment = graphql`
  fragment PageContactInfoFragment on WpPage_Pagecontent_PageContent_ContactInfo {
    extraClass
    extraId
    hideSection
    contactDetails {
      details {
        target
        title
        url
      }
      icon {
        altText
        mediaItemUrl
        title
      }
    }
    heading
    mapIframe
    socialIcons {
      icon {
        altText
        mediaItemUrl
        title
      }
      links {
        target
        title
        url
      }
    }
  }
`
